import { transitTagsGetAll } from '@/services/api-transit/transitTags';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<API.TransitTag[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(null);
  const [valueOptions, setValueOptions] = useState<{ value: string; label: string }[]>([]);

  const fetch = async (search?: string) => {
    const res = await transitTagsGetAll({ search });
    setData(res);
    setValueEnum(
      res?.reduce(
        (pre: Record<string, string>, curr: API.TransitTag) => ({
          ...pre,
          [curr.tagName!]: curr.tagName || '',
        }),
        {},
      ),
    );
    setValueOptions(
      res?.map((item: API.TransitTag) => ({
        value: item.tagName!,
        label: item.tagName || '',
      })) || [],
    );
  };

  const reset = () => {
    setData(null);
    setValueEnum(null);
    setValueOptions([]);
  };

  return {
    fetch,
    reset,
    data,
    valueEnum,
    valueOptions,
  };
};
